import React, { useEffect, useMemo, useState } from 'react';
import localization from 'assets/localization/localization';
import Images from 'assets/images/imageData';
import DarwinFilterOption from 'pages/darwinRecord/components/DarwinFilterOption';

const DarwinRecordFilter = ({
  monthOptions = [],
  selectedMonth,
  defaultMonth,
  onApply,
}) => {
  const [draftMonth, setDraftMonth] = useState(selectedMonth || defaultMonth);

  useEffect(() => {
    setDraftMonth(selectedMonth || defaultMonth);
  }, [selectedMonth, defaultMonth]);

  const selectedOption = useMemo(
    () => monthOptions.find((option) => option.id === draftMonth),
    [monthOptions, draftMonth]
  );

  const orderedMonths = useMemo(
    () => [...monthOptions].reverse(),
    [monthOptions]
  );

  const handleSubmit = (event) => {
    event.preventDefault();
    onApply(draftMonth || defaultMonth);
  };

  return (
    <form onSubmit={handleSubmit} className="darwin-filter-panel">
      <div className="darwin-filter-panel__header">
        <p className="darwin-filter-panel__title">Month</p>
        <p className="darwin-filter-panel__hint">
          Choose the payroll month to load attendance records.
        </p>
      </div>

      {selectedOption ? (
        <div className="darwin-filter-panel__selection">
          <span className="darwin-filter-panel__selection-label">Selected</span>
          <span className="darwin-filter-panel__chip">{selectedOption.name}</span>
        </div>
      ) : null}

      <div className="darwin-filter-panel__options">
        {orderedMonths.length === 0 ? (
          <p className="darwin-filter-panel__empty">No months available</p>
        ) : (
          orderedMonths.map((option) => (
            <DarwinFilterOption
              key={option.id}
              id={`darwin-month-${option.id}`}
              name="darwin-month"
              label={option.name}
              isSelected={draftMonth === option.id}
              onClick={() => setDraftMonth(option.id)}
            />
          ))
        )}
      </div>

      <div className="btn-wrapper">
        <button type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src={Images?.ArrowRight || '../images/arrow-right.png'} alt="" />
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => onApply(defaultMonth)}
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default DarwinRecordFilter;
